//Componentes generales
import React, { useContext, useEffect, useState } from "react";
import ProductList from "../../components/ProductList/ProductList";

//Context
import productsContext from "../../context/productos/productsContext";
import authContext from '../../context/authentication/authContex';

// Alertas
import Swal from 'sweetalert2'

//Estilos
import './Product.css';
import {PRINCIPAL, FONT_COLOR_DEFAULT} from '../../constants/colors';
import AbmProducts from "../../components/abmProducts/AbmProducts";

/* 
    Vista donde se gestiona toda la lógica de listado de productos.
        Donde props no se encuentra en uso.
*/
function Product(props) {

    //Context Auth
    const aContext = useContext(authContext);
    const { usuario, hasWebServiceConfigured } = aContext;
    const [actualizar,setActualizar] = useState(false);
    const [showAbm, setShowAbm] = useState(false);

    //Context Add
    const pContext = useContext(productsContext);
    const { products, actualizarProducts, actualizarProductsDB, isCargando, cargando, finalizarCarga } = pContext;

    /* 
        Disparador que se ejecuta ante la renderización del componente. El mismo se encarga de actualizar los productos disponibles del context.
    */
    useEffect(() => {
        const fn = async () => {
            await actualizarProducts();
        }
        fn();
    }, []);

    /* 
        Manejador que se encarga de la actualización de productos que sobreescribe los productos actuales por los recuperados de Softland.
    */

    const handlerActualizarProductos = async () => { 
      if(hasWebServiceConfigured){
        Swal.fire({
          title: 'Desea actualizar la lista?',
          text: "Se traeran los datos de Softland para sobreescribir la base de datos de la aplicación.",
          showCancelButton: true,
          confirmButtonText: 'Actualizar',
          cancelButtonText: 'No, cancelar',
          showLoaderOnConfirm: true,
          preConfirm: async () => {
            return await actualizarProductsDB(usuario._id, usuario.userName)
              .then(response => {
                if (!response.status) {
                  throw new Error(response.msg)
                }
                return response;
              })
              .catch(error => {
                Swal.showValidationMessage(
                  `Request failed: ${error}`
                )
              })
          },
          allowOutsideClick: () => !Swal.isLoading()
        }).then((result) => {
          if (result.isConfirmed) {
            Swal.fire(
                'Actualizado!',
                'La base de datos ha sido actualizada correctamente.',
                'success'
            )
          }
        })
      }else{
        Swal.fire({
          title:"No es posible actualizar los Productos!", 
          text:"No se ha configurado una conexión con un sistema externo, utilice el botón + en azul para dar de alta los productos en forma manual o mediante una planilla xlsx. Si desea configurar un sistema externo comuníquese con el soporte de XertuX",
          confirmButtonColor:'#3d4d87',
        });
      }
    }

    return (
        <div className="productView">
            <button className="agregar-productos-btn" onClick={()=>setShowAbm(true)}>
              +
            </button>
            <div className="actualiza-productos-container">
                <button className="actualizar-productos-btn"
                  style={{ backgroundColor: PRINCIPAL, color: FONT_COLOR_DEFAULT }}
                  onClick={handlerActualizarProductos}
                  >Actualizar Productos
                </button>
            </div>
            <ProductList productos={products} />
            {showAbm && <AbmProducts setShowAbm={setShowAbm}/>}

        </div>
    );
}

export default Product